export const isNative = () => {
  return false;
};
